export default __webpack_public_path__ + "static/media/green.e05003c6.jpg";